module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Burberry Hero: The Game","start_url":"/","background_color":"#415B5C","theme_color":"#415B5C","display":"standalone","icon":"static/assets/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"fb18bfbf26e44a43027ba976b5907ab1"},
    }]
